import { Achievement } from "./Achievement";
import { registerAchievementUnlocker } from "./Achievements";
import { loadRetirement } from "./Retirement";
import { loadDoom } from "./exploration/Doom";
import { loadStunning } from "./exploration/Stunning";
import { Storylines } from "./storylines/Storylines";
import { OfflineTickListeners } from "./timetick/OfflineTickListeners";
import { timePieceGranter } from "./timetick/TimePieces";

export function loadMisc() {
  OfflineTickListeners.register(timePieceGranter);
  registerAchievementUnlocker(
    // Optimization: check for the Holy storyline fight first
    // to avoid doing an expensive check if definitely not needed
    (state) =>
      Storylines.getById("Challenge (Holy)")?.isCompleted(state) &&
      Storylines.getAll().every((storyline) => storyline.isCompleted(state)),
    Achievement.ALL_STORYLINES_COMPLETED,
  );
  loadRetirement();
  loadStunning();
  loadDoom();
}
